/**
 * Generated by "@vuepress/internal-root-mixins"
 */
import m0 from "/usr/local/share/.config/yarn/global/node_modules/@vuepress/core/lib/client/root-mixins/updateMeta.js"
import m1 from "/dpan/ezhushou/data/vuepress/node_modules/@vuepress/plugin-active-header-links/clientRootMixin.js"
import m2 from "/dpan/ezhushou/data/vuepress/node_modules/@vuepress/plugin-nprogress/clientRootMixin.js"
import m3 from "/dpan/ezhushou/data/vuepress/node_modules/@vuepress/plugin-medium-zoom/clientRootMixin.js"

export default [
  m0,
  m1,
  m2,
  m3
]